<template>
  <v-container class="pa-5 mx-auto" style="max-width: 800px;">
    <vue-headful title="Workbook" description="Aimz"/>
    <router-link to="/dashboard">Zurück zum Dashboard</router-link>

    <div class="mt-10">

      <header1 class="mb-3 ml-n5">Aimz Workbook</header1>

      <a :href="downloadLink" target="_blank">
        <v-img :src="require('@/assets/workbook.jpg')">
        </v-img>
      </a>
      <div class="d-flex mt-5">
        <v-btn class="dunkelblau white--text mx-auto" :href="downloadLink" target="_blank">Download</v-btn>
      </div>
    </div>
    <div class="mt-10" style="max-width: 400px;">
      <header1 class="ml-n5 mb-5">Videoanleitung</header1>
      <p v-for="vid in videos">
        <a class="mt-3 mb-3" :href="vid.link" target="_blank">
          {{vid.title}}
        </a>
      </p>
    </div>
  </v-container>
</template>

<script>

import Header1 from "@/components/Header1";
export default {
  name: "AGB",
  components: {Header1},
  data() {
    return {
      downloadLink:'https://obergantschnig-my.sharepoint.com/:b:/g/personal/obergantschnig_obergantschnig_at/EQPavP0VnU1Dh1ICDJLizuAB_qX6nnL1iNT7y6bJVAzU3A?e=uTsaLP',
      videos: [
        {title:"Teil 1: Einführung und Überblick", link:"https://youtu.be/tzmyQcIVUuo"},
        {title:"Teil 2: Was bleibt?", link:"https://youtu.be/sTsqnRDeutA"},
        {title:"Teil 3: Die beste Version von mir selbst!", link:"https://youtu.be/0g4eymoyDiY"},
        {title:"Teil 4: Lebenssäule Job", link:"https://youtu.be/f6NpFvf94gg"},
        {title:"Teil 5: Lebenssäule Gesundheit", link:"https://youtu.be/jlBNudVZGi4"},
        {title:"Teil 6: Lebenssäule Soziales Umfeld", link:"https://youtu.be/ozFLUzw-ztU"},
        {title:"Teil 7: Lebenssäule Persönliche Entwicklung", link:"https://youtu.be/ghSVLUIe-Zw"},
        {title:"Teil 8: Lebenssäule Zeit für mich", link:"https://youtu.be/BvFl09MMXEM"},
        {title:"Teil 9: Meine Lebenssäulen", link:"https://youtu.be/IMhTf8NPn3g"},
        {title:"Teil 10: Mein Leben - eine Status-Quo-Analyse", link:"https://youtu.be/qaGDCxTbJ_M"},
        {title:"Teil 11: Woher kommst du?", link:"https://youtu.be/NyvJuq42aOw"},
        {title:"Teil 12: Der Blick in die Glaskugel", link:"https://youtu.be/2BC_t-3e2vE"},
        {title:"Teil 13: Meine Ziele: Was will ich überhaupt?", link:"https://youtu.be/P_xBc_71KDI"},
        {title:"Teil 14: Mein Beitrag zu einem erfüllten und glücklichen Leben", link:"https://youtu.be/Cm1iDRApDNg"},
      ],
    }
  },
  mounted() {
    this.$vuetify.goTo(0);
  }
}
</script>

<style scoped>

</style>